<template>
  <div class="search-wrap">
    <Form
      ref="searchForm"
      label-position="right"
      class="search-list-430 search-wrapper-430"
    >
      <Row class="relative" type="flex" flex="end">
        <FormItem v-if="tableType == '1'">
          <div style="margin-right: 0px">
            <CascaderYearTerms
              ref="cascaderYearTermsRef"
              :clearable="false"
              :placeholder="`请选择学期`"
              :cache-year-terms="yearTerms"
              @on-init="onYearTermsInit"
            >
            </CascaderYearTerms>
          </div>
        </FormItem>
        <FormItem>
          <ChooseSchool
            ref="chooseSchoolRef"
            :cache-school-id="cacheSchoolId"
            :cache-school-name="cacheSchoolName"
            @on-change="handleOnSchChange"
          ></ChooseSchool>
        </FormItem>
        <FormItem v-if="tableType == '2'">
          <Input
            v-model="teaSearchConds.teacherName"
            placeholder="教师姓名"
            clearable
            class="search-input-430"
          ></Input>
        </FormItem>
        <FormItem>
          <DatePicker
            v-model="month"
            type="month"
            transfer
            placeholder="选择考勤月份"
            style="width: 200px"
            @on-change="onMonthChange"
          ></DatePicker>
        </FormItem>
        <FormItem v-if="tableType == '1'">
          <Select
            v-model="searchConds.sheetSts"
            placeholder="查看确认单状态"
            class="search-select-430"
            clearable
            transfer
          >
            <Option
              v-for="item in confirmList"
              :key="item.id"
              :value="item.id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem v-if="tableType == '2'">
          <Select
            v-model="searchConds.itemSts"
            placeholder="查看确认单状态"
            class="search-select-430"
            clearable
          >
            <Option v-for="item in teaList" :key="item.id" :value="item.id">{{
              item.name
            }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select
            v-model="searchConds.settleSts"
            placeholder="结算状态"
            class="search-select-430"
            clearable
          >
            <Option
              v-for="item in settleList"
              :key="item.id"
              :value="item.id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <DatePicker
            v-model="settleMonth"
            type="month"
            placeholder="请选择结算月份"
            style="width: 200px"
            :transfer="true"
            @on-change="onSettleMonthChange"
          ></DatePicker>
        </FormItem>
        <Button
          type="primary"
          style="margin-right: 16px"
          @click="handleSearch"
        >查询</Button>
        <Button @click="handleReset">重置</Button>
      </Row>
    </Form>
  </div>
</template>

<script>
import ChooseSchool from '@c/searchBlock/ChooseSchool';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms';
import { getNextMonth } from '@/utils/moment.js';
import { schList, teaList, settleList } from '../data/index';
import { getSearchsStorage, setSearchsStorage } from '@/utils/storage';
export default {
  components: {
    ChooseSchool,
    CascaderYearTerms
  },
  props: {
    tableType: {
      type: String,
      default: '1' // 1 学校 2 教师考勤确认单
    }
  },
  data() {
    return {

      confirmList: [...schList], // 确认单列表
      teaList,
      settleList: [...settleList], // 结算状态列表

      searchConds: {
        schoolId: '',
        startDate: '',
        endDate: '',
        sheetSts: '',
        settleSts: '',
        yearCode: '',
        termCode: '',
        itemSts: '',
        settleMonth: ''
      },
      teaSearchConds: {
        teacherName: ''
      },
      month: '',
      settlemonth: '',
      yearTerms: [],
      portOrg: localStorage.getItem('portOrg'),
      cacheSchoolName: '',
      cacheSchoolId: ''
    };
  },
  created() {
    this.init();
  },
  mounted() {

  },
  methods: {
    // 初始化 搜索缓存
    init() {
      // const info = getSearchsStorage();
      // if (info) {
      //   this.searchConds.sheetSts = info.sheetSts;
      //   this.searchConds.settleSts = info.settleSts;
      //   this.searchConds.endDate = info.endDate;
      //   this.searchConds.startDate = info.startDate;
      //   this.teaSearchConds.teacherName = info.teacherName;
      //   // this.searchConds.schoolId = info.schoolId;
      //   // this.searchConds.schoolName = info.schoolName;
      //   if (info.startDate) {
      //     this.month = info.startDate.split(' ')[0];
      //   }
      //   if (info.termCode && info.yearCode) {
      //     this.yearTerms = [info.yearCode, info.termCode];
      //   }
      //   if (info.schoolId && info.schoolName) {
      //     this.searchConds.schoolId = info.schoolId;
      //     this.searchConds.schoolName = info.schoolName;
      //     this.cacheSchoolId = info.schoolId;
      //     this.cacheSchoolName = info.schoolName;
      //   }
      // }
      // console.log(info, 'info');
    },
    getSchoolName() {
      return this.searchConds.schoolName;
    },
    onYearTermsInit() {
      this.handleSearch();
    },
    // 月份改变触发
    onMonthChange(month) {
      console.log('month', month);
      if (month) {
        this.searchConds.startDate = `${month}-01 00:00:00`;
        this.searchConds.endDate = `${getNextMonth(month + '-01')} 00:00:00`;
      } else {
        this.searchConds.startDate = '';
        this.searchConds.endDate = '';
      }
    },
    onSettleMonthChange(month) {
      if (month) {
        this.searchConds.settleMonth = month;
      } else {
        this.searchConds.settleMonth = '';
      }
    },
    handleOnSchChange(info) {
      console.log('info', info);
      this.searchConds.schoolId = info.schoolId;
      this.searchConds.schoolName = info.schoolName;
    },
    handleSearch() {
      if (this.tableType == 1) {
        const yearTerms = this.$refs.cascaderYearTermsRef.getResult();
        this.searchConds.yearCode = '';
        this.searchConds.termCode = '';
        if (yearTerms.length > 1) {
          this.searchConds.yearCode = yearTerms[0];
          this.searchConds.termCode = yearTerms[1];
        }
      }
      const info = JSON.parse(JSON.stringify(this.searchConds));
      for (const k in info) {
        if (info[k] == -1) {
          info[k] = '';
        }
      }
      if (this.tableType == 2) {
        delete info.termCode;
        delete info.yearCode;
        delete info.sheetSts;
        info.teacherName = this.teaSearchConds.teacherName;
        info.dtlSts = 0;
      }

      setSearchsStorage(info);
      delete info.schoolName;
      this.$emit('on-search', info);
    },
    handleReset() {
      this.$refs.chooseSchoolRef && this.$refs.chooseSchoolRef.handleClear();
      this.$refs.cascaderYearTermsRef && this.$refs.cascaderYearTermsRef.handleDefault();
      this.searchConds = {
        schoolId: this.portOrg == 2 ? this.searchConds.schoolId : '',
        startDate: '',
        endDate: '',
        sheetSts: '',
        settleSts: '',
        yearCode: '',
        termCode: '',
        itemSts: '',
        settleMonth: ''
      };
      this.teaSearchConds.teacherName = '';
      this.month = '';
      this.settlemonth = '';
      this.handleSearch();
    }
  }
};
</script>

<style></style>
